class BrandsSalut extends HTMLElement {
  static DRAG_THRESHOLD = 5;

  connectedCallback() {
    this.row = this.querySelector('.brands-salut__row');
    this.prev = this.querySelector('[data-brands-prev]');
    this.next = this.querySelector('[data-brands-next]');
    if (!this.row) return;

    this.update = this.update.bind(this);
    this.prev.addEventListener('click', () => this.scrollBySteps(-1));
    this.next.addEventListener('click', () => this.scrollBySteps(1));
    this.row.addEventListener('scroll', this.update, { passive: true });
    new ResizeObserver(this.update).observe(this.row);

    this.enableDragging();
    this.update();
  }

  get step() {
    const item = this.row.querySelector('.brands-salut__item');
    if (!item) return this.row.clientWidth;

    const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  scrollBySteps(direction) {
    this.row.scrollBy({ left: this.step * direction, behavior: 'smooth' });
  }

  update() {
    const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
    const reserved = this.next.hidden ? 0 : this.next.offsetWidth + gap;

    this.next.hidden = this.row.scrollWidth <= this.row.clientWidth + reserved + 1;

    const max = this.row.scrollWidth - this.row.clientWidth;
    this.next.classList.toggle('is-inert', this.row.scrollLeft >= max - 1);
    this.prev.hidden = this.next.hidden || this.row.scrollLeft <= 1;
  }

  enableDragging() {
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let moved = 0;

    // Capturarea pointerului trimite si click-ul catre rand, nu catre bula de brand,
    // asa ca linkurile nu mai navigau. Se captureaza abia peste prag, adica la drag real.
    let captured = false;

    this.row.addEventListener('dragstart', (event) => event.preventDefault());

    this.row.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = this.row.scrollLeft;
      moved = 0;
      captured = false;
    });

    this.row.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const delta = event.clientX - startX;
      moved = Math.max(moved, Math.abs(delta));
      if (!captured && moved > BrandsSalut.DRAG_THRESHOLD) {
        this.row.setPointerCapture(pointerId);
        this.row.classList.add('is-dragging');
        captured = true;
      }
      if (!captured) return;
      this.row.scrollLeft = startScroll - delta;
      event.preventDefault();
    });

    const end = (event) => {
      if (event.pointerId !== pointerId) return;
      if (captured) {
        this.row.releasePointerCapture(pointerId);
        this.row.classList.remove('is-dragging');
      }
      pointerId = null;
      captured = false;
    };

    this.row.addEventListener('pointerup', end);
    this.row.addEventListener('pointercancel', end);
    this.row.addEventListener(
      'click',
      (event) => {
        if (moved > BrandsSalut.DRAG_THRESHOLD) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }
}

if (!customElements.get('brands-salut')) customElements.define('brands-salut', BrandsSalut);
